import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '0.5rem',
    fontSize: theme.size.sm,
    cursor: 'default',
    color: '#8F8F8F',
    margin: '0.5rem 10px',

    [theme.breakpoints.down('md')]: {
      margin: '0 10px'
    },

    '& > div': {
      minHeight: '17px',

      [theme.breakpoints.down('md')]: {
        height: 'auto !important'
      }
    }
  },

  alignCenter: {
    textAlign: 'center'
  },

  truncate: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  mobileHeader: {
    textAlign: 'center',
    display: 'block'
  },

  mobileHeaderDate: {
    textAlign: 'center',
    display: 'block'
  }
}))

export default useStyles
